<template>
  <a-modal
    v-model:visible="rateVisible"
    class="rateDialog"
    :bodyStyle="{ textAlign: 'center' }"
    title=""
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <h3>您觉得课程怎么样？</h3>
    <a-form ref="rateFormRef" class="rateForm" :model="rateForm" :rules="rateFormRules">
      <a-form-item name="rateValue">
        <span>
          <a-rate v-model:value="rateForm.rateValue" :tooltips="desc" />
          <span class="ant-rate-text">{{ desc[rateForm.rateValue - 1] }}</span>
        </span>
      </a-form-item>
      <a-form-item name="rateText">
        <a-textarea v-model:value="rateForm.rateText" placeholder="请输入评价" :rows="4" />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button class="rateBtn" key="submit" type="primary" size="large" @click="handleOk">提交</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'RateDialog',
  data() {
    return {
      rateVisible: false,
      rateForm: {
        rateValue: 0,
        rateText: '',
      },
      desc: ['课程内容难', '课程一般般', '课程还不错', '课程收获多', '课程非常棒'],
      rateFormRules: {
        rateValue: [{ pattern: /[^0]+/, message: '请评分', trigger: 'change' }],
        rateText: [{ required: true, message: '请输入评价', trigger: 'change' }],
      },
      courseId: '',
      courseType: '',
    }
  },
  mounted() {
    this.$bus.on('rateDialog', (e) => {
      this.courseId = e.id
      this.courseType = e.type
      this.openRateDialog()
    })
  },
  methods: {
    openRateDialog() {
      this.rateVisible = true
    },
    async handleOk() {
      try {
        const values = await this.$refs.rateFormRef.validateFields()
        // console.log('Success:', values)
        const { data: res } = await this.$http.post('index/comment', {
          type:  this.courseType,
          id:  this.courseId,
          star: this.rateForm.rateValue,
          content: this.rateForm.rateText,
          time: '',
        })
        if (res.code == 100) {
          return this.$message.warning(`${res.msg}`)
        }
        this.$bus.emit('getCourserOrder')
        this.$message.success('评价成功！')
        this.$refs.rateFormRef.resetFields()
        this.rateVisible = false
      } catch (errorInfo) {
        // console.log('Failed:', errorInfo.outOfDate)
      }
    },
    handleCancel() {
      this.$refs.rateFormRef.resetFields()
    },
  },
}
</script>

<style lang="less" scoped>
.rateDialog {
  h3 {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }
  .ant-rate {
    font-size: 36px;
    margin-bottom: 16px;
  }
  .rateBtn {
    display: block;
    width: 150px;
    margin: 0 auto;
  }
  .ant-form-item {
    margin-bottom: 0px;
  }
}
</style>
